const widgetName = 'socialNetworkWidget';
let initialized = false;
let windowSize = $(window).width();

function initialize() {
  $(`#${widgetName}`).append('<div class="socialTabContainer" role="tablist"></div>');

  $(`#${widgetName}`).on('click keydown', '.socialNetworkTab', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      const tab = $(this).attr('data-social-network-tab');

      $('.socialNetworkTab').removeClass('activeTab');
      $('.socialNetworkTab').attr('aria-selected', false);
      $('.socialFeedContainer').hide();

      $(this).addClass('activeTab');
      $(this).attr('aria-selected', true);
      $(`#${tab}Container`).show();
    }
  });

  initialized = true;
}

function isCurrent(current, widget) {
  if (current) {
    $(`#${widgetName} #${widget}Tab`).addClass('activeTab');
    $(`#${widgetName} #${widget}Tab`).attr('aria-selected', true);
    $(`#${widgetName} #${widget}Container`).show();
  }
}

// FACEBOOK -----------

function facebookfeed(current) {
  const fbPageURL = $('.socialNetworkIconFacebook').attr('href');
  const fbHeight = 479;
  const fbWidth = 511;

  const facebookfeedTab = `
  
  <a href="${fbPageURL}" target="_blank" id="facebookfeedTab" class="socialNetworkTab" data-social-network-tab="facebookfeed"  role="tab" aria-selected="false" aria-controls="facebookfeedContainer" tabindex="0">      
<a href=" https://www.instagram.com/cityofvictoria_pio/" class="insta socialNetworkTab" aria-hidden="true" target="_blank"></a>
  <div class="social-title"> 
  <a href="https://www.facebook.com/CityofVictoriaTexas/" target="_blank"></a>
</div>
</a>
  `;
  const facebookfeedContainer = `
    <div id="facebookfeedContainer" class="socialFeedContainer" role="tabpanel" aria-labelledby="facebookfeedTab">
      <div class="fb-page" data-href="${fbPageURL}" data-width="${fbWidth}" data-adapt-container-width="true" data-height="${fbHeight}" data-small-header="true" data-hide-cover="false" data-show-facepile="false" data-show-posts="true">
        <div class="fb-xfbml-parse-ignore">
          <blockquote cite="${fbPageURL}"><a href="${fbPageURL}">Loading...</a></blockquote>
        </div>
      </div>
    </div>
  `;

  if ((!isMobile && !initialized) || windowSize >= 800) {
    initialize();
  }

  if (!isMobile || windowSize >= 800) {
    $(`#${widgetName} .socialTabContainer`).append(facebookfeedTab);
    $(`#${widgetName}`).append(facebookfeedContainer);
    isCurrent(current, 'facebookfeed');
  }

  $('#videoSection').before(`
    <div id="social-mobile">
    ${facebookfeedTab}
    </div>
    `);
}

export { facebookfeed };
